'use client';

import { FC } from 'react';
import { Container, Wrapper } from '@/features/pages/home';
import feedbackGrassLeft from '@/assets/svg/feedback-grass-1.svg';
import feedbackGrassRight from '@/assets/svg/feedback-grass-2.svg';
import { BgFigure } from './styles';
import { Typography } from '@mui/material';
import { COLORS } from '@/constants';
import dynamic from 'next/dynamic';

const Carousel = dynamic(
  () => import('./Carousel/Carousel').then((m) => ({ default: m.Carousel })),
  { ssr: false },
);
import { useTranslations } from 'next-intl';

export const Feedback: FC = () => {
  const t = useTranslations();
  return (
    <Wrapper $bgColor="beige-parch">
      <BgFigure>
        <img src={feedbackGrassLeft.src} alt="background-decoration" />
      </BgFigure>
      <Container>
        <Typography
          fontSize={{ xs: 26, sm: 26, md: 34 }}
          fontWeight={700}
          color={COLORS['gray-dark']}
          textAlign={'center'}
          marginBottom={3}
          position={'relative'}
          zIndex={10}
        >
          {t('feedback.title')}
        </Typography>
        <Carousel />
      </Container>
      <BgFigure $isRight>
        <img src={feedbackGrassRight.src} alt="background-decoration" />
      </BgFigure>
    </Wrapper>
  );
};
